const publicFailureCodes = new Set([
  "auth0_email_not_verified", "mfa_required", "external_identity_not_linked",
  "auth0_registration_required", "auth0_link_password_to_google",
  "auth0_link_google_to_password", "auth0_existing_account_link_required", "account_not_active",
])

export function exchangeFailureCode(error: unknown): string {
  const detail = error instanceof Error ? error.message : ""
  return publicFailureCodes.has(detail) ? detail : "auth0_exchange_failed"
}

export function recoveryTarget(code: string | null | undefined): "google" | "password" | null {
  if (code === "auth0_link_password_to_google") return "password"
  if (code === "auth0_link_google_to_password") return "google"
  return null
}
